const DATE = 'date';
const STRING = 'string';
const ARRAY = 'array';

const getPropType = prop => {
  if (!prop || !prop.type) return null;
  return Array.isArray(prop.type) ? prop.type[0] : prop.type;
};
const checkForStringTypeProps = (identifier, relations, isSelectedEntity, props) =>
  Object.keys(props).reduce((accVal, key) => {
    const prop = props[key];
    const propType = getPropType(prop);
    const propFormFieldType = prop.formFieldType;
    const isSearchable = !!prop.searchable;
    const isArray = propType && propType === ARRAY;
    const isStringType = propType && (propType.includes(STRING) || propType === STRING);
    const isNotDate = (propFormFieldType && propFormFieldType !== DATE) || !propFormFieldType;
    const isArrayOfStrings = isArray && getPropType(prop.items) === STRING;

    if (isSearchable && isNotDate && (isStringType || isArrayOfStrings)) {
      if (isSelectedEntity) accVal.push(key);
      else {
        const [relation] = relations.filter(
          ({ entityIdentifier }) => entityIdentifier === identifier
        );

        if (relation) accVal.push(`${identifier}.${key}`);
      }
    }
    return accVal;
  }, []);

const getStringTypeProps = (entities, relations, entitySchemas) => {
  const entity = Array.isArray(entities) ? entities[0] : entities;
  return entitySchemas.reduce((acc, entitySchema) => {
    const { identifier, properties = {}, dynamicProperties = {} } = entitySchema;
    const isSelectedEntity = identifier === entity;

    acc.push(
      ...checkForStringTypeProps(identifier, relations, isSelectedEntity, properties),
      ...checkForStringTypeProps(identifier, relations, isSelectedEntity, dynamicProperties)
    );

    return acc;
  }, []);
};

module.exports = { getStringTypeProps };
